import { registerFunctionalComponent } from 'js/lib/components/component'
import { useFormInput } from 'js/lib/form'

registerFunctionalComponent('.js-c-input--button', 'InputButton', InputButton)

function InputButton(component) {
  const { onDependentChange, form } = useFormInput(component.element)
  const disableOnSubmit = component.element.dataset.disableOnSubmit === 'true'

  component.useHandler(() => form.on('submit', handleFormSubmit))
  onDependentChange(dependency => handleDependentChange(component.element, dependency))

  function handleFormSubmit(event) {
    const isSubmitter = event.submitter === component.element

    if (isSubmitter) {
      updateLoading(component.element, true)
    }

    if (disableOnSubmit) {
      updateDisabled(component.element, true)
    }
  }
}

function handleDependentChange(input, dependency) {
  switch (dependency.behaviour.type) {
    case 'value':
      updateValue(input, dependency.behaviour.getValue())
      break
    case 'text':
      updateText(input, dependency.behaviour.getText())
      break
  }
}

function updateLoading(input, value) {
  const loadingElement = input.querySelector('.js-c-form-input-button__loading-state')

  if (value === true) {
    loadingElement.classList.remove('tw-hidden')
  } else {
    loadingElement.classList.add('tw-hidden')
  }
}

function updateText(input, value) {
  input.textContent = String(value)
  input.dispatchEvent(new window.Event('change', { bubbles: true, cancelable: true }))
}

function updateValue(input, value) {
  input.value = String(value)
  input.dispatchEvent(new window.Event('change', { bubbles: true, cancelable: true }))
}

function updateDisabled(input, shouldDisable) {
  if (shouldDisable) {
    input.disabled = true
    input.setAttribute('disabled', '')
  } else {
    input.disabled = false
    input.removeAttribute('disabled')
  }
}
